<template>
  <Modal v-model:is-open="isOpen" class="cart-collision-modal">
    <div class="flex items-center justify-between">
      <h1 class="font-secondary text-size_6 font-bold leading-none">
        Start a new cart?
      </h1>

      <IconButton :c_style="{ type: 'ghost' }" @click="handleClose">
        <CommonUIcons name="ic-x" class="h-icon_size_5 w-icon_size_5" />
      </IconButton>
    </div>

    <p
      class="font-secondary text-size_4 font-bold leading-none text-neutral-800"
    >
      We've found items saved from your previous shopping session. Do you want
      to combine both carts or start fresh with the new cart?
    </p>

    <div class="flex flex-col gap-5">
      <Button
        class="w-full"
        label="Combine Both Carts"
        @click="$emit('merge')"
      />
      <Button
        class="w-full"
        :c_style="{ type: 'secondary' }"
        label="Start a New Cart"
        @click="$emit('claim')"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import Modal from "~/components/common/Atom/Modal.vue";
import IconButton from "~/components/common/Atom/IconButton.vue";

const isOpen = defineModel("isOpen", { default: false });

const emits = defineEmits(["close", "merge", "claim"]);

const handleClose = () => {
  isOpen.value = false;
  emits("close");
};
</script>

<style>
.cart-collision-modal {
  .modal-content {
    @apply flex max-w-[330px] flex-col gap-10 pb-14 pt-7 md:max-w-[550px];
  }
}
</style>
